import { Button } from "./button.component";
import { CertificateInterface } from "../features/caregiver/addCaregiver.component";
import { DateInput, FileInput } from "./textInput.component";
import { useEffect, useState } from "react";
import fileUploadLogo from "../assets/img/UploadCertificate.svg";
import { ApiSchemaCaregiverCertificate } from "../models/api";

export const AddCertificateOnCaregiver = ({
  onChange,
  value,
  uploadedCertificates,
  handleRemove,
  removeCertificates,
}: {
  onChange?: (certificates: CertificateInterface[]) => void;
  value?: CertificateInterface[];
  uploadedCertificates?: ApiSchemaCaregiverCertificate[];
  handleRemove?: (doc: string) => void;
  removeCertificates?: string[];
}) => {
  const [certificates, setCertificates] = useState<CertificateInterface[]>(
    value ?? []
  );

  const handleAddTaskButtonClick = () =>
    setCertificates([
      ...certificates,
      {
        certificateFile: undefined,
        expiationDate: undefined,
      },
    ]);

  useEffect(() => {
    setCertificates(value ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onChange && onChange(certificates);
  }, [onChange, certificates]);

  return (
    <div className="border rounded m-0 p-3 mt-2 mb-3">
      <div className="row">
        <div className="col">
          <Button
            name="+ Add Certificate"
            onClick={handleAddTaskButtonClick}
            type="button"
            className={`btn-green-subtle ${!certificates.length ? "" : "mb-3"}`}
          />
        </div>
      </div>
      {certificates.map((certificate, index) => {
        return (
          <div
            key={index}
            className="row add-task-border m-1 mb-3 p-2 pt-3 rounded position-relative"
          >
            <div className="col-12 mb-1">
              <span
                className="fs-3 text-red-300 position-absolute click me-2"
                style={{ top: 0, right: 0 }}
                onClick={() =>
                  setCertificates(certificates.filter((_, i) => i !== index))
                }
              >
                x
              </span>
            </div>
            <div className="col-md-6 px-1">
              {!certificate.certificateFile ? (
                <FileInput
                  listType="text"
                  imageSrc={fileUploadLogo}
                  name="CertificateFile"
                  onChange={(value) =>
                    setCertificates(
                      certificates.map((cert, i) =>
                        i === index
                          ? ({
                              ...cert,
                              certificateFile: value,
                            } as unknown as CertificateInterface)
                          : cert
                      )
                    )
                  }
                  value={certificate.certificateFile}
                >
                  Upload Certificates
                </FileInput>
              ) : (
                <div className="d-flex flex-column px-0 m-auto">
                  <div
                    key={certificate.certificateFile[0].name}
                    className="py-1 d-flex align-items-center"
                  >
                    <img
                      src={fileUploadLogo}
                      alt="Uploaded Item"
                      className="me-2"
                      height={35}
                    />
                    <p className="text-break w-100">
                      {certificate.certificateFile[0].name}
                    </p>
                  </div>
                </div>
              )}
            </div>

            <DateInput
              name="ExpirationDate"
              onChange={(value) =>
                setCertificates(
                  certificates.map((cert, i) =>
                    i === index
                      ? ({
                          ...cert,
                          expiationDate: value,
                        } as unknown as CertificateInterface)
                      : cert
                  )
                )
              }
              value={certificate.expiationDate}
              required
            >
              Expiration Date
            </DateInput>
          </div>
        );
      })}
      {uploadedCertificates &&
        uploadedCertificates.map((certificate, index) => {
          return (
            <div
              key={index}
              className="row add-task-border m-1 mb-3 p-2 pt-3 rounded position-relative"
            >
              <div className="col-12 mb-1">
                <span
                  className={`fs-3 ${
                    removeCertificates &&
                    removeCertificates.includes(certificate.certificateFile)
                      ? "text-green-300"
                      : "text-red-300"
                  }  position-absolute click me-2`}
                  style={{ top: 0, right: 0 }}
                  onClick={() =>
                    handleRemove && handleRemove(certificate.certificateFile)
                  }
                >
                  {removeCertificates &&
                  removeCertificates.includes(certificate.certificateFile)
                    ? "+"
                    : "x"}
                </span>
              </div>
              <div className="col-md-6 px-1">
                <div className="d-flex flex-column px-0 m-auto">
                  <div
                    key={certificate.certificateFile}
                    className="py-1 d-flex align-items-center"
                    style={{
                      color:
                        removeCertificates &&
                        removeCertificates.includes(certificate.certificateFile)
                          ? "red"
                          : "black",
                      textDecoration:
                        removeCertificates &&
                        removeCertificates.includes(certificate.certificateFile)
                          ? "line-through"
                          : "none",
                    }}
                  >
                    <img
                      src={fileUploadLogo}
                      alt="Uploaded Item"
                      className="me-2"
                      height={35}
                    />
                    <p className="text-break w-100">
                      {certificate.certificateFile
                        .split("_")
                        .slice(2)
                        .join("_")}
                    </p>
                  </div>
                </div>
              </div>

              <DateInput
                name="ExpirationDate"
                value={new Date(certificate.expirationTime)}
                required
              >
                Expiration Date
              </DateInput>
            </div>
          );
        })}
    </div>
  );
};
